import { defineStore } from "pinia"

export const useUserStore = defineStore('user', {
    state: () => ({
        first_name: window.user?.first_name,
        last_name: window.user?.last_name,
        email: window.user?.email
    }),
    actions: {
        set(payload) {
            this.first_name = payload.first_name
            this.last_name = payload.last_name
            this.email = payload.email
        }
    }
  })
